export const id = {
    "n1": "halaman depan",
    "n2": "Memesan",
    "n3": "berdagang",
    "n4": "tim",
    "n5": "milikku",
    "t1": "Ada yang salah",
    "t2": "Salin berhasil",
    "t3": "Silakan isi informasi secara lengkap",
    "t4": "memuat…",
    "t5": "Login berhasil",
    "t6": "Skor harus lebih besar dari 3 sebelum mengirimkan",
    "t7": "Pengajuan berhasil",
    "t8": "Keseimbangan yang tidak mencukupi, tidak dapat dikumpulkan",
    "t9": "Pengajuan gagal",
    "t10": "Harap ikat alamat terlebih dahulu, dan halaman Pusat Pribadi akan diarahkan ke halaman Pusat Pribadi.",
    "t11": "Alamat telah terikat, silakan hubungi Layanan Pelanggan untuk memodifikasinya",
    "t12": "Modifikasi berhasil",
    "t13": "Modifikasi gagal",
    "t14": "Silakan hubungi Layanan Pelanggan untuk memodifikasi kata sandi Anda",
    "t15": "Kesalahan format kata sandi",
    "t16": "Penarikan yang berhasil",
    "t17": "Hingga menarik uang tunai",
    "t18": "Penarikan tunai minimum",
    "t19": "Kata sandi tidak konsisten dua kali",
    "t20": "petunjuk",
    "t21": "Tidak bisa melompat untuk saat ini",
    "t22": "Kesalahan format kata sandi",
    "t23": "Terdaftar dengan sukses",
    "t24": "Harap masukkan kode area",
    "t25": "Tidak ada lagi",
    "l1": "bahasa",
    "l2": "Harap masukkan nomor akun Anda",
    "l3": "Harap masukkan kata sandi Anda",
    "l4": "Ingat",
    "l5": "Masuk",
    "l6": "Pergi untuk mendaftar",
    "l7": "Tidak ada akun",
    "l8": "Nomor telepon",
    "l9": "nama panggilan",
    "l10": "kata sandi",
    "l11": "Konfirmasi Kata Sandi",
    "l12": "Kode undangan",
    "l13": "daftar",
    "l14": "Sudah memiliki akun",
    "l15": "Pergi masuk",
    "l16": "Harap masukkan kata sandi 6-16 digit",
    "bz1": "membantu",
    "bz2": "Pertanyaan yang sering diajukan",
    "bz3": "Aturan Perdagangan",
    "bz4": "Bagaimana Menarik Uang",
    "bz5": "Cara menambah",
    "bz6": "1. Apa itu robot ulasan eBay?",
    "bz7": "Ebay Review Robot adalah perusahaan promosi pemasaran yang membantu ebay meninjau robot toko online pedagang di seluruh dunia mendapatkan lebih banyak penjualan pesanan dan meningkatkan data browsing untuk robot robot online toko. Kami berkomitmen untuk membangun model pemasaran dan promosi yang menguntungkan tiga partai antara robot ebay robot dan pedagang dan konsumen. Menggabungkan teknologi blockchain P2P terbaru, dengan cepat menghubungkan konsumen dan pedagang melalui USDT (TRC20, ERC20). Pengguna terdaftar dapat menerima komisi atas pesanan, sementara pedagang dapat meningkatkan data penjualan toko. Ini adalah model laba terbaru dalam model blockchain internet!",
    "bz8": "2. Bagaimana cara kerja robot robot ebay?",
    "bz9": "Melalui umpan balik harian dari robot review eBay, ditunjukkan bahwa ketika menjual produk yang membutuhkan perbaikan pada robot review eBay, pengguna hanya perlu dengan mudah mengklik pesanan, dan sistem akan secara otomatis menghasilkan langganan pesanan. Pengguna membayar jumlah pesanan melalui blockchain USDT dan menerima komisi harian.",
    "bz10": "3. Mengapa ada perbedaan harga mata uang yang sama dalam dua transaksi?",
    "bz11": "Perbedaan harga disebabkan oleh semua faktor yang tidak kondusif terhadap sirkulasi mata uang bebas, termasuk kecepatan transfer mata uang, kondisi jaringan, pembatasan akses mata uang, pengakuan orang atas mata uang oleh berbagai daerah, dan bahkan jenis pasangan transaksi yang disediakan oleh pertukaran dan transaksi. Oleh karena itu, mata uang yang sama dapat menciptakan perbedaan harga dalam transaksi yang berbeda.",
    "bz12": "4. Laba investasi?",
    "bz13": "Semakin tinggi harga barang yang Anda dapatkan, semakin tinggi laba yang Anda dapatkan dalam pesanan. Pada saat yang sama, robot review eBay secara acak mengalokasikan perintah komisi besar.",
    "bz14": "Setiap hari, sistem secara otomatis menghasilkan dan mendistribusikan 60 pesanan produk kepada pengguna. Pengguna menyelesaikan pembayaran setiap pesanan melalui USDT dan menerima komisi 0,6%. Perintah komisi besar dialokasikan secara acak.",
    "bz15": "USDT dapat menarik uang tunai setelah 60 pesanan. (Jika 60 pesanan tidak selesai, sistem akan secara otomatis berhenti ke volume pesanan yang tersisa hari itu)",
    "bz16": "Setiap akun hanya dapat terikat pada satu akun USDT. Jika terjadi kesalahan, silakan hubungi Layanan Pelanggan.",
    "bz17": "Setelah menyelesaikan pengiriman pesanan harian, Anda dapat menarik uang tunai secara normal dan tiba dalam waktu 24 jam setelah memulai penarikan, dan tidak ada batasan penarikan.",
    "bz18": "Sebelum mengisi ulang, silakan ikat alamat penarikan Anda (mendukung TRC-20) Alamat USDT. Anda dapat mengklik aplikasi atau halaman web untuk mengisi ulang dan memilih blockchain (TRC-20) yang Anda gunakan untuk mengisi ulang.",
    "bz19": "Mengisi ulang atau mentransfer uang antara akun terkait tidak diizinkan. Ini adalah tindakan jahat dalam meraih perintah dan secara serius mempengaruhi pengoperasian platform. Jika Anda menemukan perilaku seperti itu, sistem akan segera membekukan akun dan membatalkan kualifikasi kerja.",
    "ty1": "Tentu",
    "ty2": "Membatalkan",
    "ty3": "kirim",
    "ty4": "Alamat TRC20",
    "ty5": "Alamat ERC20",
    "s1": "Pendapatan kumulatif",
    "s2": "Melayani",
    "s3": "tentang kami",
    "s4": "membantu",
    "s5": "Mitra",
    "s6": "Layanan saya",
    "d1": "Tidak selesai",
    "d2": "Selesai",
    "d3": "Belum ada data",
    "d4": "Nomor tunggal",
    "d5": "Waktu perdagangan",
    "d6": "Jumlah",
    "d7": "Jumlah tugas saat ini",
    "d8": "Penghasilan yang Diharapkan",
    "d9": "Membutuhkan",
    "d10": "skor",
    "j1": "Saldo akun",
    "j2": "Pendahuluan Transaksi",
    "j3": "robot ulasan eBay menggunakan umpan balik dari robot ebay review setiap hari untuk menampilkan produk yang dijual oleh robot ulasan eBay yang perlu ditingkatkan. Pengguna hanya perlu mengklik pesanan dan sistem akan secara otomatis menghasilkan tanda tangan pesanan. Pengguna membayar jumlah pesanan melalui blockchain USDT dan menerima komisi lebih dari 0,6% setiap kali. Sistem secara acak mengalokasikan pesanan hadiah besar.",
    "j4": "Mulailah cocok",
    "j5": "Penghasilan hari ini",
    "j6": "Nomor Selesai",
    "j7": "Total Jumlah Tugas",
    "td1": "Keseimbangan",
    "td2": "komisi",
    "td3": "menerima",
    "td4": "Jumlah total orang",
    "td5": "pengguna",
    "td6": "menyumbang",
    "td7": "kuantitas",
    "td8": "negara",
    "g1": "Penarikan",
    "g2": "Top up",
    "g3": "Undang teman",
    "g4": "Undang sekarang",
    "g5": "Anda akan menerima proporsi komisi yang sesuai untuk setiap laba yang Anda peroleh setelah mendaftarkan teman",
    "g6": "informasi pribadi",
    "g7": "Detail Pendanaan",
    "g8": "Catatan Isi Ulang",
    "g9": "Catatan penarikan",
    "g10": "bahasa",
    "g11": "Keluar",
    "g12": "Apakah Anda pasti akan keluar?",
    "yh1": "Informasi pengguna",
    "yh2": "Merevisi",
    "yh3": "mendirikan",
    "yh4": "Telepon",
    "yh6": "Kata Sandi Asli",
    "yh7": "Kata sandi baru",
    "mx1": "Menerima komisi",
    "mx2": "penghasilan",
    "mx3": "Penolakan penarikan",
    "mx4": "waktu",
    "mx5": "Isi ulang dengan sukses",
    "mx6": "Ditolak",
    "mx7": "Tertunda",
    "mx8": "Alamat penarikan",
    "mx9": "Saldo yang tersedia",
    "mx10": "Tanda terima aktual",
    "mx11": "Harap masukkan jumlah penarikan",
    "cz2": "menyalin",
    "cz3": "Pemilihan Mata Uang Filipina",
    "cz4": "Membayar",
    "cz5": "Alamat setoran hanya mendukung TRC20-USDT, dan jumlah deposit minimum adalah 20USDT.",
    "cz6": "Alamat setoran hanya mendukung ERC20, jumlah deposit minimum adalah 20USDT",
    "cz1": "Alamat setoran hanya mendukung ERC20, jumlah deposit minimum adalah 20USDT",
    "qy1": "Kode wilayah",
    "yq1": "Undang teman",
    "yq2": "Kode undangan",
    "yq3": "Mengundang teman dan menikmati keuntungan besar",
    "yq4": "Pergi dan mengundang",
    "zf1": "Metode pengisian ulang",
    "zf2": "Pilih metode Recharge",
    "zf3": "Mata Uang Perdagangan",
    "zf4": "Jaringan perdagangan",
    "zf5": "Pergi ke transaksi",
    "zf6": "Salin berhasil",
    "zf7": "Mata Uang Perdagangan",
    "zf8": "Tolong gunakan",
    "zf9": "Transfer uang ke alamat di bawah ini untuk menyelesaikan isi ulang.",
    "zf10": "Mata Uang Perdagangan",
    "zf11": "menyalin",
    "zf12": "Silakan periksa alamatnya dengan cermat, kesalahan tidak akan diambil",
    "zf13": "Waktu kedatangan",
    "zf14": "Sekitar 1 hingga 5 menit",
    "zf15": "Jumlah pengisian ulang minimum"
  }
  